"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExchangeStatus = void 0;
exports.ExchangeStatus = {
    Created: 'CREATED',
    Submitted: 'SUBMITTED',
    HolderDeclined: 'HOLDER_DECLINED',
    Expired: 'EXPIRED',
    Accepted: 'ACCEPTED',
    VerifierDeclined: 'VERIFIER_DECLINED'
};
